import React, { useEffect, Component, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { Table, Modal } from 'react-bootstrap'
import StarRatings from 'react-star-ratings'
import { Sidebar } from '../sidebar/Sidebar'
import Navbar from '../navbar/navbar'
import profile from '../images/profile.jpg'
import UpdateBusinessForm from '../UpdateBusinessForm/UpdateBusinessForm'
import { businessData } from '../demoData/demoData.js'
import { deleteBusiness, getBusiness } from '../../../Services/business.service'
import ConfirmationModal from '../../shared/confirmationModal/confirmationModal'
import AdminAddBusiness from '../AdminAddBusiness/AdminAddBusiness'
import _ from 'lodash';
import { getCategories } from '../../../Services/category.service'
import { getReviewsCount } from '../../../Services/reviews.service';

export const AdminAllListings = () => {
  const [idOfEditObject, SetIdOfEditObject] = useState('')
  const [showEditForm, setShowEditForm] = useState(false)
  const [editItem, setEditItem] = useState(null)
  const [data, setData] = useState([])
  const [isConfirm, setIsConfirm] = useState(false)
  const [filteredList, setFilteredList] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [categoriesList, setCategoriesList] = useState([])

  const redColor = {
    color: 'red'
  }
  const greenColor = {
    color: '#28CB89'
  }

  useEffect(() => {
    // getAllCategories();
    getAllBusiness()
  }, [])

  const handleCloseEdit = () => {
    console.log("close modal");
    getAllBusiness()
    setShowEditForm(false)
  }

  const handleShowEdit = (id, item) => {
    setEditItem(item)
    SetIdOfEditObject(id)
    setShowEditForm(true)
  }

  // let getAllCategories = () => {
  //   getCategories().then(resp => {
  //     setCategoriesList(resp)
  //   })
  // }

  let getAllBusiness = async () => {
    let business = await getBusiness();
    let categories = await getCategories();

    getReviewsCount().then(r => {
      console.log("reviews", r)
      let reviewsList = []
      reviewsList = r;
      _.forEach(business, (b) => {
        b.totalReviews = 0;
        for (let i = 0; i <= reviewsList.length - 1; i++) {
          if (b.businessId == reviewsList[i].businessId) {
            b.totalReviews++;
          }
        }

        for (let j = 0; j <= categories.length - 1; j++) {
          if (b.category == categories[j].categoryId) {
            b.categoryName = categories[j].name;
          }
        }

      })
      setData(business)
      console.log('get business', business)
    })
    // setData(business)
    // console.log('get business', business)
  }

  const removeHandle = (id, index) => {
    console.log(id, index);
    if (!!id) {
      deleteBusiness(id).then(resp => {
        console.log('delete resp', resp);
        const removeArr = [...data].filter(todo => todo.businessId !== id) //all id matches except which we want to remove
        data.splice(index, 1)
        setData(removeArr) //remove from state
        setIsConfirm(false)
        localStorage.removeItem('bId')
        localStorage.removeItem('indexId')
      })
    }

  }

  const updateData = val => {
    console.log(idOfEditObject)
    console.log(val) //updated value
    for (var i = 0; i < data.length; i++) {
      if (data[i].id === idOfEditObject) {
        if (val.BusinessName != '') {
          data[i].BName = val.BusinessName
        }
        if (val.category != '') {
          data[i].category = val.category
        }
        if (val.fullAddress != '') {
          data[i].address = val.fullAddress
        }
        if (val.description != '') {
          data[i].description = val.description
        }
        if (val.status != '') {
          data[i].status = val.status
        }
        // return;
      }
    }
    setTimeout(function () {
      handleCloseEdit()
    }, 300)
    // setData(businessData);
  }

  let toggleModal = (businessId, index) => {
    localStorage.bId = businessId
    localStorage.indexId = index
    setIsConfirm(true)
  }

  let handleSearchValue = (value) => {
    console.log(value);
    let search = value;
    search = search.trim();
    search = search.toLowerCase();

    if (!!search) {
      setSearchValue(search)
      let localList = [];
      _.forEach(data, (value) => {

        if (_.includes((value.name).toLowerCase(), search) || _.includes((value.address).toLowerCase(), search) || _.includes((value.category).toLowerCase(), search)) {
          localList.push(value);
        }

      });
      setFilteredList(localList)
    }
    else {
      setSearchValue(search)
      let localList = [];
      setFilteredList(localList)
    }
  }

  let processCategory = (categoryId) => {
    console.log(categoryId);
    _.forEach(categoriesList, (c) => {
      console.log(c);
      if (c.categoryId == categoryId) {
        console.log(c.name);
        return c.name
      }
    })
  }

  return (
    <>
      {/* Page Wrapper */}
      <div id='wrapper'>
        {/* Sidebar */}
        <Sidebar />
        {/* End of Sidebar */}
        {/* Content Wrapper */}
        <div id='content-wrapper' className='d-flex flex-column'>
          {/* Main Content */}
          <div id='content'>
            <Navbar setValue={handleSearchValue} />

            {/* Begin Page Content */}
            <div className='container-fluid'>
              {/* Content Row */}
              <div className='row'>
                <div className='col'>
                  <h2 className='theme-color'>All Business</h2>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <Table
                    responsive
                    striped
                    bordered
                    hover
                    className='bg-white dashboardTable'
                  >
                    <thead>
                      <tr>
                        <th>Listing Name</th>
                        <th>Category</th>
                        <th>Address</th>
                        <th>Description</th>
                        <th>Ratings</th>
                        <th>Status</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {!!searchValue ?
                        filteredList.length > 0 ?
                          filteredList.map((item, index) =>
                            <tr key={index}>
                              <td>
                                <div className='d-flex ai-center'>
                                  <img
                                    className='driver-img rounded-circle'
                                    src={item.logoURL}
                                  />
                                  <span className='mr-2 fs-14 small profile-name ml-2 w-mc'>
                                    {item.name}
                                  </span>
                                </div>
                              </td>
                              <td>{item.categoryName}</td>
                              <td>
                                <p className='mb-0 w-mc fs-14'>{item.address}</p>
                              </td>
                              <td className='mw220 fs-14'>{item.description}</td>
                              <td>
                                <div className='w-mc'>
                                  {/* {item.totalReviews} */}
                                  <StarRatings
                                rating={item.businessCount}
                                starDimension='18px'
                                starSpacing='1px'
                                numberOfStars={5}
                                starRatedColor='orange'
                              />
                                </div>
                              </td>
                              <td className='fs-14'>{item.status ? 'Active' : 'Deactive'}</td>
                              <td>
                                <button
                                  className='btn btn-success w-100 fs-14'
                                  onClick={() => handleShowEdit(item.businessId, item)}
                                >
                                  Edit
                                </button>
                              </td>
                              <td><button className="btn btn-success w-100 fs-14">
                                <NavLink to={{
                                  pathname: "/admin/business-details",
                                  businessData: item
                                }} className="color-white">Detail</NavLink>
                              </button>
                              </td>
                              <td>
                                <button
                                  className='btn btn-danger w-100 fs-14'
                                  onClick={() => toggleModal(item.businessId, index)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          )
                          :
                          <tr>
                            <td className="fs-14 text-center" colSpan={9}>Nothing found...</td>
                          </tr>
                        :
                        data.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div className='d-flex ai-center'>
                                <img
                                  className='driver-img rounded-circle'
                                  src={item.logoURL}
                                />
                                <span className='mr-2 fs-14 small profile-name ml-2 w-mc'>
                                  {item.name}
                                </span>
                              </div>
                            </td>
                            <td>{item.categoryName}</td>
                            <td>
                              <p className='mb-0 w-mc fs-14'>{item.address}</p>
                            </td>
                            <td className='mw220 fs-14'>{item.description}</td>
                            <td>
                              <div className='w-mc'>
                                {/* {item.totalReviews} */}
                                <StarRatings
                                  rating={item.businessCount}
                                  starDimension='18px'
                                  starSpacing='1px'
                                  numberOfStars={5}
                                  starRatedColor='orange'
                                />
                              </div>
                            </td>
                            <td className='fs-14'>{item.status ? 'Active' : 'Deactive'}</td>
                            <td>
                              <button
                                className='btn btn-success w-100 fs-14'
                                onClick={() => handleShowEdit(item.businessId, item)}
                              >
                                Edit
                              </button>
                            </td>
                            <td><button className="btn btn-success w-100 fs-14">
                              <NavLink to={{
                                pathname: "/admin/business-details",
                                businessData: item
                              }} className="color-white">Detail</NavLink>
                            </button>
                            </td>
                            <td>
                              <button
                                className='btn btn-danger w-100 fs-14'
                                onClick={() => toggleModal(item.businessId, index)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </div>
          {/* End of Main Content */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}

      {/* Scroll to Top Button*/}
      <a className='scroll-to-top rounded' href='#'>
        <i className='fas fa-angle-up' />
      </a>
      {/* Edit business modal */}
      <Modal
        show={showEditForm}
        onHide={handleCloseEdit}
        className='addBusinessModal'
      >
        <Modal.Header>
          <div className=' headerColor  text-center col-12'>
            <h3 className='bold-font h4 mb-0 themeColor2 text-center'>
              <i className='fa fa-envelope' /> Edit Business
            </h3>
          </div>
          <span className='close' onClick={handleCloseEdit}>
            <i class='fa fa-times' aria-hidden='true'></i>
          </span>
        </Modal.Header>
        <AdminAddBusiness setHandleClose={handleCloseEdit} businessData={editItem} />
        {/* <UpdateBusinessForm val={updateData} businessData={editItem} /> */}
      </Modal>
      {isConfirm ?
        <ConfirmationModal isShowModal={isConfirm}
          callback={(type) => {
            console.log('callback type', type);
            if (type == 'delete') {
              removeHandle(localStorage.bId, localStorage.indexId)
            }
            else if (type == 'hide') {
              setIsConfirm(false)
            }
          }}
        />
        :
        null
      }
    </>
  )
}
